import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  Routes,
} from "@angular/router";
import { LocalStorage } from "./localStorage";
import { GenEnum } from "../../shell/shared/general.enum";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  activityobj: any;

  constructor(private router: Router, private localStorage: LocalStorage) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (state.url === "/") {
      this.router.navigate(["login"]);
      return false;
    }

    this.activityobj = JSON.parse(this.localStorage.get("blkactivity"));
    const usertype = JSON.parse(this.localStorage.get("utuser"));

    if (
      usertype != null &&
      usertype &&
      usertype.usercatid === GenEnum.User_Category.Parent
    ) {
      if (Number(this.localStorage.get("Studentid")) == 0) {
        this.router.navigate(["login"]);
        return false;
      }
      if (this.router && this.router.config) {
        var grdcomp = this.router.config.filter(
          (o) => o.path === "" && o.component.name === "Guardiancomponent"
        )[0];
        if (grdcomp) {
          let rtnvalue = grdcomp.children.filter(
            (x) =>
              x.path.toLowerCase() === state.url.replace("/", "").toLowerCase()
          )[0];
          if (rtnvalue && this.activityobj) {
            let blockactivitylist = this.activityobj.filter(
              (c) =>
                c.activityid.toLowerCase() ===
                state.url.replace("/", "").toLowerCase()
            )[0];
            if (blockactivitylist) {
              this.router.navigate(["login"]);
              return false;
            } else {
              return true;
            }
          }
        }
      }
    }

    return this.checkToken();
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.canActivate(route, state);
    return this.checkToken();
  }

  private checkToken() {
    if (this.localStorage.get("token")) {
      return true;
    }

    this.router.navigate(["login"]);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helper/auth.guard.ts